import apiService from '../utils/apiInterceptor';

const xeroIntegrationService = {
  getStatus: async (clientId) => {
    return await apiService.get('/integrations/xero/status', { params: { client_id: clientId } });
  },
  getConnectUrl: async (clientId) => {
    return await apiService.get('/integrations/xero/connect', { params: { client_id: clientId } });
  },
  listConnections: async () => {
    return await apiService.get('/integrations/xero/connections');
  },
  disconnect: async (clientId) => {
    return await apiService.post('/integrations/xero/disconnect', { client_id: clientId });
  },
  listTenants: async (clientId) => {
    return await apiService.get('/integrations/xero/tenants', { params: { client_id: clientId } });
  },
  setTenant: async ({ clientId, tenantId, tenantName, connectionId }) => {
    return await apiService.post('/integrations/xero/tenant', {
      client_id: clientId,
      tenant_id: tenantId,
      tenant_name: tenantName,
      connection_id: connectionId,
    });
  },
  listAccounts: async () => {
    return await apiService.get('/integrations/xero/accounts');
  },
  getAccountConnectUrl: async (accountId, oauthApp = 'xero') => {
    return await apiService.get('/integrations/xero/accounts/connect', {
      params: accountId ? { account_id: accountId } : { oauth_app: oauthApp },
    });
  },
  updateAccount: async (accountId, payload) => {
    return await apiService.put(`/integrations/xero/accounts/${accountId}`, payload);
  },
  disconnectAccount: async (accountId) => {
    return await apiService.post(`/integrations/xero/accounts/${accountId}/disconnect`);
  },
  syncInvoiceToXero: async (invoiceId) => {
    return await apiService.post(`/invoices/${invoiceId}/sync/xero`);
  },
};

export default xeroIntegrationService;
